export default __webpack_public_path__ + "static/media/bag7.3ca07a47.jfif";